<template>
  <div class="demand-detail-container">
    <a-spin :spinning="loading" size="large" class="loading-spin" />
    
    <div class="detail-wrapper">
      <!-- 左侧主内容区 -->
      <div class="detail-main">
        <!-- 头部区域 -->
        <div class="detail-header fade-in">
          <h1 class="detail-title">{{ detail.name }}</h1>
          <div class="detail-meta">
            <div class="meta-item" v-if="detail.requirementUnit || detail.contactName">
              <a-icon type="environment" class="meta-icon" />
              <span>{{ detail.requirementUnit }}<template v-if="detail.requirementUnit && detail.contactName"> / </template>{{ detail.contactName }}</span>
            </div>
            <div class="meta-item" v-if="detail.createTime">
              <a-icon type="clock-circle" class="meta-icon" />
              <span>{{ detail.createTime }}</span>
            </div>
          </div>
          <div class="detail-tags" v-if="detail.tag">
            <a-icon type="tag" />
            <a-tag v-for="(tag, index) in detail.tag.split(',')" :key="index" color="blue" class="tag-item">
              {{ tag }}
            </a-tag>
          </div>
        </div>

        <!-- 主体内容区 -->
        <div class="detail-content fade-in-delay">
          <div class="content-section" v-if="overviewInfo.length">
            <h2 class="section-title">
              <a-icon type="profile" class="title-icon" />
              基本信息
            </h2>
            <div class="info-grid">
              <div class="info-item" v-for="(item, index) in overviewInfo" :key="index">
                <div class="info-label">{{ item.label }}</div>
                <div class="info-value">{{ item.value }}</div>
              </div>
            </div>
          </div>

          <div class="content-section" v-if="contactInfo.length">
            <h2 class="section-title">
              <a-icon type="team" class="title-icon" />
              联系与发布信息
            </h2>
            <div class="contact-card">
              <div class="contact-item" v-for="(item, index) in contactInfo" :key="index">
                <div class="contact-label">{{ item.label }}</div>
                <div class="contact-value">
                  {{ item.value }}
                  <span v-if="item.masked" class="contact-hint">（完整信息提交申请后可见）</span>
                </div>
              </div>
            </div>
          </div>

          <div class="content-section" v-for="(section, index) in detailSections" :key="section.title + index">
            <h2 class="section-title">
              <a-icon :type="section.icon" class="title-icon" />
              {{ section.title }}
            </h2>
            <div
              class="section-text"
              v-if="section.isHtml"
              v-html="section.content"
            ></div>
            <div
              class="section-text"
              v-else
              v-html="section.content"
            ></div>
          </div>
        </div>
      </div>

      <!-- 右侧操作栏 -->
      <div class="detail-sidebar fade-in-delay-2">
        <a-button type="primary" size="large" block class="contact-btn" @click="handleApplyClick">
          <a-icon type="rocket" />
          我要揭榜
        </a-button>

        <!-- 担保交易卡片 -->
        <div class="trust-card">
          <div class="trust-item" v-for="(item, index) in trustItems" :key="index">
            <a-icon :type="item.icon" class="trust-icon" />
            <div class="trust-text">{{ item.text }}</div>
          </div>
        </div>

        <!-- 客服热线 -->
        <div class="service-card">
          <a-icon type="phone" class="service-icon" />
          <div class="service-title">客服热线</div>
          <div class="service-phone">400-6655-930</div>
        </div>

        <!-- 类似需求列表 -->
        <div class="similar-requirements">
          <h3 class="similar-title">
            <a-icon type="appstore" class="title-icon" />
            类似需求
          </h3>
          <div class="similar-list">
            <div 
              class="similar-item" 
              v-for="(item, index) in similarItems" 
              :key="index"
              @click="handleSimilarClick(item)"
            >
              <a-icon type="right" class="item-arrow" />
              <span class="item-text">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- 我要揭榜弹窗 -->
    <a-modal
      v-model="isApplyModalVisible"
      title="我要揭榜"
      :width="600"
      @ok="handleApplySubmit"
      @cancel="handleApplyCancel"
    >
      <a-form layout="vertical" :form="applyForm">
        <a-form-item label="姓名">
          <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]" placeholder="请输入姓名"></a-input>
        </a-form-item>
        
        <a-form-item label="手机号码">
          <a-input v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号码' }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }] }]" placeholder="请输入手机号码"></a-input>
        </a-form-item>
        
        <a-form-item label="所在单位">
          <a-input v-decorator="['unit', { rules: [{ required: true, message: '请输入所在单位' }] }]" placeholder="请输入所在单位"></a-input>
        </a-form-item>
        
        <a-form-item label="研究领域(产业领域)">
          <j-category-select
                  v-decorator="['technicalField', { rules: [{ required: true, message: '请输入研究领域' }] }]" 
                  pcode="B03"
                  placeholder="请选择技术领域"
                />
          <!-- <a-input v-decorator="['researchField', { rules: [{ required: true, message: '请输入研究领域' }] }]" placeholder="请输入研究领域"></a-input> -->
        </a-form-item>
        
        <a-form-item label="方案简述">
          <a-textarea v-decorator="['description', { rules: [{ required: true, message: '请输入方案简述' }] }]" rows="4" placeholder="请输入方案简述"></a-textarea>
        </a-form-item>
        
        <a-form-item label="附件">
          <j-upload v-decorator="['fileUrl', { rules: [{ required: true, message: '请上传附件' }] }]" :maxFile="1" :trigger-change="true"></j-upload>
          
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getAction, httpAction } from '@/api/manage'
import Area from '@/components/_util/Area'
import { ACCESS_TOKEN, TENANT_ID } from "@/store/mutation-types"
import JUpload from '@/components/jeecg/JUpload'
import JCategorySelect from "@comp/jeecg/JCategorySelect";

export default {
  components: {
    JUpload,
    JCategorySelect
  },
  name: 'DemandDetail',
  data() {
    return {
      loading: false,
      pcaData: null,
      detail: {
        name: '',
        requirementUnit: '',
        contactName: '',
        createTime: '',
        budget: null,
        technicalField: '',
        industryField: '',
        companyName: '',
        requirementType: '',
        contactPhone: '',
        areaId: '',
        isOpen: '',
        urgentLevel: '',
        keyQuestion: '',
        tag: '',
        techLevel: '',
        restrictFactor: '',
        tryEffort: '',
        planConstraint: '',
        predictProfit: '',
        expRequire: '',
        investMoney: '',
        resourceDescription: '',
        solveType: '',
        refRequirement: ''
      },
      similarItems: [
        '基于蛋白化+电解质补充双益发酵乳的开发与示范',
        '基于新疆特色果粮的药食同源发酵乳关键技术及产业化示范',
        '智能葡萄仓储术改造',
        '玉米高效制种生产及加工关键技术示范与应用'
      ],
      trustItems: [
        { icon: 'safety', text: '担保交易' },
        { icon: 'check-circle', text: '认证保障' },
        { icon: 'file-protect', text: '安全可靠' }
      ],
      // API接口配置
      url: {
        save: '/xjtech/techInteraction/add'
      },
      // 我要揭榜弹窗相关数据
      isApplyModalVisible: false,
      applyForm: this.$form.createForm(this),
      fileList: []
    }
  },
  mounted() {
    this.pcaData = new Area()
    this.loadDetail()
  },
  computed: {
    overviewInfo() {
      return [
        { label: '需求类型', value: this.detail.requirementType_dictText || '' },
        { label: '所属行业', value: this.detail.industryField_dictText || '' },
        { label: '技术领域', value: this.detail.technicalField_dictText == '其他' ? this.detail.technicalField_dictText+'('+this.detail.technicalFieldCustom+')':this.detail.technicalField_dictText || '' },
        { label: '需求地域', value: this.detail.areaId_dictText || this.getAreaText(this.detail.areaId) || '' },
        { label: '预算经费', value: this.formatBudget(this.detail.budget) },
        { label: '紧急程度', value: this.detail.urgentLevel_dictText || '' },
        { label: '是否公开', value: this.detail.isOpen_dictText || '' },
        //{ label: '关联企业', value: '****' },
        { label: '预期收益', value: this.detail.predictProfit_dictText || '' },
        { label: '投入金额', value: this.detail.investMoney_dictText || '' }
      ].filter(item => this.hasDisplayValue(item.value))
    },
    contactInfo() {
      const info = []
      if (this.detail.requirementUnit) {
        info.push({ label: '需求单位', value: this.detail.requirementUnit })
      }
      if (this.detail.contactName) {
        info.push({ label: '联系人', value: this.detail.contactName })
      }
      if (this.detail.contactPhone) {
        info.push({
          label: '联系电话',
          value: this.maskPhone(this.detail.contactPhone),
          masked: true
        })
      }
      if (this.detail.createTime) {
        info.push({ label: '发布时间', value: this.detail.createTime })
      }
      return info
    },
    detailSections() {
      const sections = [
        {
          title: '需求详情',
          icon: 'file-text',
          value: this.detail.keyQuestion,
          isHtml: true
        },
        {
          title: '技术水平',
          icon: 'experiment',
          value: this.detail.techLevel
        },
        {
          title: '制约因素',
          icon: 'alert',
          value: this.detail.restrictFactor
        },
        {
          title: '已投入的努力与成本',
          icon: 'tool',
          value: this.detail.tryEffort
        },
        {
          title: '方案约束',
          icon: 'audit',
          value: this.detail.planConstraint
        },
        {
          title: '经历要求',
          icon: 'idcard',
          value: this.detail.expRequire
        },
        {
          title: '投入资源描述',
          icon: 'appstore',
          value: this.detail.resourceDescription
        },
        {
          title: '需求解决方式',
          icon: 'deployment-unit',
          value: this.detail.solveType_dictText || this.formatMultiValue(this.detail.solveType)
        },
        {
          title: '关联服务需求',
          icon: 'cluster',
          value: this.detail.refRequirement_dictText || this.formatMultiValue(this.detail.refRequirement)
        }
      ]
        .filter(section => this.hasDisplayValue(section.value))
        .map(section => ({
          ...section,
          content: section.isHtml ? section.value : this.formatMultiline(section.value)
        }))

      return sections
    }
  },
  methods: {
    loadDetail() {
      const id = this.$route.query.id
      if (!id) {
        this.$message.error('缺少需求ID')
        return
      }

      this.loading = true
      getAction('/xjtech/techRequirement/queryById', { id })
        .then(res => {
          if (res.success) {
            this.detail = res.result
          } else {
            this.$message.error(res.message || '加载失败')
          }
        })
        .catch(err => {
          console.error('加载需求详情失败:', err)
          this.$message.error('加载失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSimilarClick(item) {
      // 处理类似需求点击事件
      this.$message.info(`查看需求: ${item}`)
    },
    formatBudget(value) {
      if (value === null || value === undefined || value === '') {
        return '面议'
      }
      const num = Number(value);
      if (!isNaN(num)) {
        if (num >= 10000) {
          return `${(num / 10000).toFixed(num % 10000 === 0 ? 0 : 1)}万`;
        }
        return `${num}元`;
      }
     return value;
    },
    maskPhone(phone) {
      if (!phone) return ''
      const str = String(phone)
      if (str.length < 7) return str
      return `${str.slice(0, 3)}****${str.slice(-4)}`
    },
    formatMultiValue(value) {
      if (!value) return ''
      if (Array.isArray(value)) {
        return value.join('、')
      }
      return value
        .split(',')
        .map(item => item.trim())
        .filter(Boolean)
        .join('、')
    },
    formatMultiline(value) {
      if (!value) return ''
      return value.replace(/\n/g, '<br/>')
    },
    hasDisplayValue(value) {
      return !(value === undefined || value === null || value === '')
    },
    getAreaText(code) {
      if (!code || !this.pcaData) {
        return ''
      }
      return this.pcaData.getText(code)
    },
    // 我要揭榜弹窗相关方法
    handleApplyClick() {
      this.isApplyModalVisible = true
    },
    handleApplySubmit() {
      this.applyForm.validateFields((err, values) => {
        if (!err) {
          // 准备提交数据
          const data = {
            ...values,
            type: 2,
            techId: this.$route.query.id,
          }
          
          // 提交表单
          httpAction(this.url.save, data, 'post')
            .then((res) => {
              if (res.success) {
                this.$message.success('提交成功')
              } else {
                this.$message.warning(res.message || '提交失败')
              }
            })
            .finally(() => {
              this.isApplyModalVisible = false
              this.applyForm.resetFields()
            })
        }
      })
    },
    handleApplyCancel() {
      this.isApplyModalVisible = false
      this.applyForm.resetFields()
    },
  }
}
</script>

<style scoped lang="less">
// 动画定义
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.demand-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  position: relative;
  min-height: 100vh;
  //background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  background-attachment: fixed;

  .loading-spin {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }
}

.detail-wrapper {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.detail-main {
  flex: 1;
  min-width: 0;
}

// 淡入动画类
.fade-in {
  animation: fadeIn 0.6s ease-out;
}

.fade-in-delay {
  animation: fadeIn 0.6s ease-out 0.2s both;
}

.fade-in-delay-2 {
  animation: slideInRight 0.6s ease-out 0.4s both;
}

.detail-header {
  background: #fff;
  padding: 40px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  }

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  .detail-title {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 24px;
    line-height: 1.4;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .detail-meta {
    display: flex;
    gap: 40px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .meta-item {
      display: flex;
      align-items: center;
      gap: 10px;
      color: #666;
      font-size: 15px;
      padding: 8px 16px;
      background: #f8f9fa;
      border-radius: 20px;
      transition: all 0.3s ease;

      &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
      }

      .meta-icon {
        color: #667eea;
        font-size: 16px;
        animation: float 3s ease-in-out infinite;
      }
    }
  }

  .detail-tags {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    .anticon {
      color: #667eea;
      font-size: 16px;
    }

    .tag-item {
      margin: 0;
      padding: 4px 12px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
      }
    }
  }
}

.detail-sidebar {
  width: 320px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;

  .contact-btn {
    height: 56px;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .anticon {
      font-size: 20px;
    }

    &:hover {
      background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .trust-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 30px 20px;
    border-radius: 16px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
    }

    .trust-item {
      text-align: center;
      color: #fff;
      transition: all 0.3s ease;
      padding: 10px;
      border-radius: 8px;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: scale(1.1);
      }

      .trust-icon {
        font-size: 36px;
        margin-bottom: 12px;
        display: block;
        animation: float 3s ease-in-out infinite;
        animation-delay: calc(var(--i, 0) * 0.2s);
      }

      .trust-text {
        font-size: 14px;
        font-weight: 500;
      }

      &:nth-child(1) {
        --i: 0;
      }
      &:nth-child(2) {
        --i: 1;
      }
      &:nth-child(3) {
        --i: 2;
      }
    }
  }

  .service-card {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    padding: 30px;
    border-radius: 16px;
    text-align: center;
    color: #fff;
    margin-bottom: 20px;
    box-shadow: 0 8px 25px rgba(245, 87, 108, 0.3);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: pulse 3s ease-in-out infinite;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 35px rgba(245, 87, 108, 0.4);
    }

    .service-icon {
      font-size: 48px;
      margin-bottom: 15px;
      display: block;
      animation: float 2s ease-in-out infinite;
      position: relative;
      z-index: 1;
    }

    .service-title {
      font-size: 16px;
      margin-bottom: 12px;
      font-weight: 500;
      position: relative;
      z-index: 1;
    }

    .service-phone {
      font-size: 24px;
      font-weight: 700;
      letter-spacing: 2px;
      position: relative;
      z-index: 1;
    }
  }

  .similar-requirements {
    background: #fff;
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    }

    .similar-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
      color: #333;
      display: flex;
      align-items: center;
      gap: 8px;
      padding-bottom: 12px;
      border-bottom: 2px solid #f0f0f0;

      .title-icon {
        color: #667eea;
        font-size: 20px;
      }
    }

    .similar-list {
      .similar-item {
        padding: 14px 12px;
        border-bottom: 1px solid #f0f0f0;
        color: #666;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 8px;
        margin-bottom: 4px;

        &:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }

        &:hover {
          background: linear-gradient(90deg, rgba(102, 126, 234, 0.1) 0%, transparent 100%);
          color: #667eea;
          padding-left: 16px;
          transform: translateX(4px);
        }

        .item-arrow {
          font-size: 12px;
          opacity: 0;
          transition: all 0.3s ease;
          color: #667eea;
        }

        &:hover .item-arrow {
          opacity: 1;
        }

        .item-text {
          flex: 1;
          line-height: 1.6;
        }
      }
    }
  }
}

.detail-content {
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  }

  .content-section {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 22px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 24px;
      padding-bottom: 12px;
      border-bottom: 3px solid;
      border-image: linear-gradient(90deg, #667eea 0%, #764ba2 100%) 1;
      display: flex;
      align-items: center;
      gap: 10px;

      .title-icon {
        color: #667eea;
        font-size: 24px;
        animation: float 2s ease-in-out infinite;
      }
    }

    .section-text {
      color: #555;
      line-height: 2;
      font-size: 15px;

      // 美化 HTML 内容样式
      ::v-deep p {
        margin-bottom: 16px;
      }

      ::v-deep ul,
      ::v-deep ol {
        padding-left: 24px;
        margin-bottom: 16px;
      }

      ::v-deep li {
        margin-bottom: 8px;
      }

      ::v-deep strong {
        color: #333;
        font-weight: 600;
      }

      ::v-deep code {
        background: #f5f5f5;
        padding: 2px 6px;
        border-radius: 4px;
        font-family: 'Courier New', monospace;
      }
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 12px;
  }

  .info-item {
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    background: #fafbff;
    min-height: 94px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: box-shadow 0.3s ease, transform 0.3s ease;

    &:hover {
      box-shadow: 0 8px 20px rgba(102, 126, 234, 0.15);
      transform: translateY(-2px);
    }
  }

  .info-label {
    color: #888;
    font-size: 13px;
    margin-bottom: 6px;
  }

  .info-value {
    font-size: 16px;
    font-weight: 600;
    color: #2d2d2d;
  }

  .contact-card {
    background: #f7f9ff;
    border-radius: 12px;
    padding: 24px;
    border: 1px solid rgba(102, 126, 234, 0.2);
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .contact-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .contact-label {
    font-size: 13px;
    color: #6b6b6b;
  }

  .contact-value {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .contact-hint {
    font-size: 12px;
    color: #999;
    font-weight: 400;
    margin-left: 4px;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .detail-wrapper {
    flex-direction: column;
  }

  .detail-sidebar {
    width: 100%;
    position: static;
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .demand-detail-container {
    padding: 12px;
  }

  .detail-header {
    padding: 24px;

    .detail-title {
      font-size: 24px;
    }

    .detail-meta {
      gap: 16px;
    }
  }

  .detail-content {
    padding: 24px;
  }

  .detail-sidebar {
    .contact-btn {
      height: 48px;
      font-size: 16px;
    }

    .trust-card {
      padding: 20px 15px;

      .trust-item {
        .trust-icon {
          font-size: 28px;
        }
      }
    }
  }
}
</style>